import styled from 'styled-components'

export const Container = styled.div`
    border-radius: inherit;
    overflow: hidden;
    pointer-events: none;
    position: relative;
`

export const Canvas = styled.canvas`
    display: block;
    height: 100%;
    width: 100%;
`

export const Dim = styled.div`
    backdrop-filter: grayscale(1);
    height: 100%;
    opacity: 0.7;
    position: absolute;
    top: 0;
`
